import { render, staticRenderFns } from "./Draggable.vue?vue&type=template&id=50ffffb3&scoped=true"
import script from "./Draggable.vue?vue&type=script&lang=js"
export * from "./Draggable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50ffffb3",
  null
  
)

export default component.exports